import Priority from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Priority/Priority";
import SafetyAlarm from "@coworker/apprestructured/src/task-management/components/TaskCard/components/SafetyAlarm/SafetyAlarm";
import styles from "./Badges.module.css";

type BadgesProps = {
  priority: boolean;
  safetyAlarm?: boolean;
  dim?: boolean;
};

function Badges({ priority, safetyAlarm, dim = false }: BadgesProps) {
  if (!priority && !safetyAlarm) return null;

  return (
    <div data-testid="badges" className={styles["root"]}>
      {priority && <Priority dim={dim} />}
      {safetyAlarm && <SafetyAlarm dim={dim} />}
    </div>
  );
}

export default Badges;
